import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import { Button, Dialog, Grid } from "@mui/material";
import Signifier from "../../../../../App/Components/Signifier/Signifier";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../../../../App/State/Slices/SelectedCareersClientSlice";
import FeaturedEventsTableCell from "./FeaturedEventsTableCell";
import SortableTable from "../../../../../App/Components/Table/SortableTable";
import { getFeaturedEvents } from "../../../FeaturedEventsService";
import { basicSort } from "../../../../../App/Helpers/BasicSort";
import { basicConvertDate } from "../../../../../App/Helpers/DateConverters";
import AddFeaturedEventModal from "../../AddFeaturedEventModal";

function FeaturedEventsPage() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    autocomplete: {
      width: "35%",
      paddingBottom: "20px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    hint: {
      position: "absolute",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      marginTop: "auto",
      marginBottom: "auto",
      marginLeft: "auto",
      marginRight: "auto",
      width: "300px",
      height: "300px",
      fontSize: "32px",
      textAlign: "center",
      color: "rgba(0,0,0,.6)",
    },
  }));

  const classes = useStyles();

  const selectCareersClient = useSelector(selectCareersClientValue);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);

  const columns = [
    { label: "Title", propName: "event.title" },
    { label: "Start Date", propName: "event.startDate" },
    { label: "End Date", propName: "event.endDate" },
    { label: "Delete", propName: "" },
  ];

  useEffect(() => {
    if (selectCareersClient !== null) {
      setLoading(true);
      getFeaturedEvents(selectCareersClient.id).then((response) => {
        response.sort((a, b) => {
          const order = basicSort(a.order, b.order);
          if (order !== 0) return order;
          return a[1] - b[1];
        });
        response.forEach(
          (row) => (row.event.startDate = basicConvertDate(row.event.startDate))
        );
        response.forEach(
          (row) => (row.event.endDate = basicConvertDate(row.event.endDate))
        );
        setTableData(response);
        setLoading(false);
      });
    }
  }, [selectCareersClient]);

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <div className={classes.root}>
        {selectCareersClient === null ? (
          <div className={classes.hint}>
            <span>Select a client</span>
          </div>
        ) : (
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12}>
              <Button
                style={{ marginTop: "0px", marginBottom: "20px" }}
                type="submit"
                variant="contained"
                color="primary"
                onClick={() => setOpenAddModal(!openAddModal)}
              >
                Add Event
              </Button>
            </Grid>
            <SortableTable
              columns={columns}
              tableData={tableData}
              rowComponent={FeaturedEventsTableCell}
              loading={loading}
              setTableData={setTableData}
              defaultSortIndex={1}
            />
          </Grid>
        )}
      </div>
      <Dialog open={openAddModal} onClose={() => setOpenAddModal(false)}>
        <AddFeaturedEventModal
          openModal={setOpenAddModal}
          client={selectCareersClient}
          setShowSignifier={setShowSignifier}
          setResponseMessage={setResponseMessage}
          setShowError={setShowError}
          setTableData={setTableData}
        />
      </Dialog>
    </>
  );
}

export default FeaturedEventsPage;
